/* eslint-disable react-hooks/exhaustive-deps */
import {
	Button,
	DialogActions,
	Grid,
	TextField,
	Typography,
	makeStyles,
} from "@material-ui/core/";
import { useSnackbar } from "notistack";
import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { config as url } from "../../../common/config";
import AlertNotistack from "../../../components/molecules/AlertNotistack";
import Dropzones from "../../../components/molecules/Dropzone";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";

const useStyles = makeStyles((theme) => ({
	textField: {
		marginBottom: 16,
	},
	form: {
		border: "1px solid rgba(0, 0, 0, 0.23)",
		borderRadius: 4,
		padding: "18.5px 14px",
		width: "95%",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
		},
	},
}));

const SetupInitialization = () => {
	const BaseUrl = `${url.login}`;
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();
	const fetchData = useContext(FetchDataContext);
	const { addDataForm } = fetchData;
	const [selectFile1, setSelectFile1] = useState({ file: [] });
	const [selectFile2, setSelectFile2] = useState({ file: [] });

	const { handleSubmit, errors, register, clearErrors } = useForm();

	const handleFetch = () => {
		return true;
	};
	const fetchAPI = async (action, data) => {
		let result;
		if (action === "addForm")
			result = await addDataForm(
				`${BaseUrl}/identitas/edit`,
				data,
				handleFetch
			);
		return result;
	};

	const checkHandleSubmit = async (data) => {
		if (selectFile1.file >= 0) {
			enqueueSnackbar("Images Banner Required", AlertNotistack("error"));
		} else if (selectFile2.file >= 0) {
			enqueueSnackbar("Images logo Required", AlertNotistack("error"));
		} else {
			await onSubmit(data);
		}
	};

	const onSubmit = async (data) => {
		const formData = new FormData();
		Object.values(selectFile1).forEach((file, index) => {
			formData.append("nama_aplikasi", data?.nama_aplikasi);
			formData.append("lokasi", data?.lokasi);
			if (file) {
				formData.append("images_banner", file);
			}
			return selectFile1;
		});
		Object.values(selectFile2).forEach((file, index) => {
			if (file) {
				formData.append("images_logo", file);
			}
			return selectFile2;
		});

		let result = await fetchAPI("addForm", formData);
		if (result.status === "success") {
			clearErrors();
			window.location.reload();
		}
		return result;
	};

	return (
		<Grid
			direction="column"
			alignItems="center"
			style={{
				backgroundColor: "white",
				boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
			}}
		>
			<form className={classes.form} onSubmit={handleSubmit(checkHandleSubmit)}>
				<Grid container>
					<Grid container>
						<TextField
							fullWidth
							variant="outlined"
							style={{ marginBottom: "1rem" }}
							name="nama_aplikasi"
							id="aplikasi"
							title="Nama Aplikasi"
							label="Apllication Name"
							error={errors.nama_aplikasi}
							inputRef={register({
								required: {
									value: true,
									message: "Nama Aplikasi tidak boleh kosong",
								},
							})}
							InputLabelProps={{ shrink: true }}
							helperText={errors.nama_aplikasi && errors.nama_aplikasi.message}
							// required
						></TextField>
						<TextField
							fullWidth
							variant="outlined"
							style={{ marginBottom: "1rem" }}
							name="lokasi"
							id="lokasi"
							title="Lokasi"
							label="lokasi"
							error={errors.lokasi}
							inputRef={register({
								required: {
									value: true,
									message: "lokasi tidak boleh kosong",
								},
							})}
							InputLabelProps={{ shrink: true }}
							helperText={errors.lokasi && errors.lokasi.message}
							// required
						></TextField>
					</Grid>
					<Grid container>
						<Typography variant="h3">Images Banner </Typography>
						<Dropzones
							state={selectFile1}
							setState={setSelectFile1}
							type="initial"
						/>
					</Grid>
					<Grid container>
						<Typography variant="h3">Images Logo </Typography>
						<Dropzones
							state={selectFile2}
							setState={setSelectFile2}
							type="initial"
						/>
					</Grid>

					<DialogActions
						style={{
							width: "100%",
						}}
					>
						<Grid
							className="form-group"
							style={{
								display: "flex",
								justifyContent: "end",
							}}
						>
							<Button
								type="submit"
								// disabled={state.loading}
								variant="contained"
								color="primary"
							>
								Submit &#10148;
							</Button>
						</Grid>
					</DialogActions>
				</Grid>
			</form>
		</Grid>
	);
};
export default SetupInitialization;
